import useAssessmentsPending from "./useAssessmentsPending";
import useAssessmentPageBlock from "./useAssessmentPageBlock";
import useLang from "../../../hooks/useLang";

const usePendingList = () => {
  const lang = useLang();
  const assessments = useAssessmentsPending();

  const items = useAssessmentPageBlock({ assessments });

  const page = {
    hasAccess: assessments?.hasAccess,
    header: {
      title: assessments?.isLoading
        ? lang("assessments.assessments_loading")
        : lang("assessments_pending.title"),
    },
    paging: { ...assessments?.pagination },
    items,
  };
  return page;
};

export default usePendingList;
